import { Utils } from 'src/app/utils';
import { PackageProductLogsRequest, ProdLogTask, ProdLogTaskResponse, ProductInstanceRow, ProductLog, SupportedProductLogs } from './../../model/Product';
import { Component, OnInit } from '@angular/core';
import { SupportService } from 'src/app/service/support.service';
import { FileSizePipe } from 'src/app/pipe/file-size.pipe';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { ProductDataType, ProductsComponent, ProductTreeType } from '../products/products.component';
import { ActivityService, ActivityType } from 'src/app/service/activity.service';
import { Modal } from '../controls/modal/modal.service';
import { Events, WebsocketService } from 'src/app/service/websocket.service';
import { DataService } from 'src/app/service/data.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { EventService } from 'src/app/service/event.service';
import { DiscoveredProduct, ProductComponent, ProductExt, ProductInstance } from 'src/app/model/Product';
import { Agent } from 'src/app/model/Agent';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { InstanceDetailsComponent } from '../dialogs/instance-details/instance-details.component';
import { ActivityCapabilitiesRequest, ActivityCapabilitiesType, ActivityTask, ActivityTaskType } from 'src/app/model/TaskStatus';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { FromNowPipe } from 'src/app/pipe/from-now.pipe';
import { LoginPackageLogsComponent, ProductLoginResult } from '../dialogs/login-package-logs/login-package-logs.component';
import { SolutionService } from 'src/app/service/solution.service';

@Component({
    selector: 'app-product-component-logs-create',
    templateUrl: './product-component-logs-create.component.html',
    styleUrls: ['./product-component-logs-create.component.css'],
    standalone: false
})
export class ProductComponentLogsCreateComponent extends ProductsComponent implements OnInit {

  started: boolean = false;
  freeDiskSpace: string = "0";
  logTaskResponse: ProdLogTaskResponse;
  agentsLoading: boolean = false;
  title: string = "";
  agentTableTitle: string = $localize`Instances`;
  agentCols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "37.5", ColumnSort.DESC),
    new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "29.5"),
    new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "10"),
    new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "15"),
    new DataTableColumn("agentStatus", $localize`Agent status`, ColumnType.STATUSEXT, false, "8"),
  );
  agentRows: DataTableRow[] = [];
  logColClass: string = "ot-checkbox-options";
  productId:number;
  setupid:string;
  platform:string;
  activeProduct:ProductExt;  
  currEnvId:number;
  isQuickAnalysisRequired = false;
  isMasterSystemSelected = true;
  isReload:boolean = false;
  isMasterSystemOnline:boolean = true;
  isSupportHotfix = false;
  selectedInstancesFromPreviousPage:ProductInstanceRow[] = [];  
  activeComponent:ProductComponent;
  activeProductInstances:Record<string, ProductInstance[]>;
  
  supportedProductLogs:SupportedProductLogs = new SupportedProductLogs("", "", "");
  selectAllLabel:string = $localize`Select all`;
  isSelectAllChecked:boolean = true;
  backURL: string;
  agentsTableHeight: string;
  recountSelectedRow: boolean = false;
  isAuthRequired: boolean = false;
  productURL: string = '';
  productToken: string = '';

  packageForm = new FormGroup({
    packageNameCtrl: new FormControl('', [
      Validators.required,
      Validators.pattern("[a-zA-Z0-9\-\_ ]*"), //avoid special characters in file name
      Validators.maxLength(70)
    ]),
    selectedEnvironmentCtrl: new FormControl({value: "", disabled: true}, [
      Validators.required, 
    ]),
    includeMgrLogsCtrl: new FormControl('', [])
  });

  constructor(protected eventService: EventService,
              protected authService:AuthenticationService,
              protected siService:SoftwareInventoryService,
              protected dataService:DataService,
              protected wsService: WebsocketService,
              protected router: Router,
              protected modal: Modal,
              protected activityService: ActivityService,
              private route: ActivatedRoute,
              private supportService:SupportService,
              protected solutionService: SolutionService) {
                super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
                //check if instances were passed in
                if(this.router.currentNavigation() &&
                    this.router.currentNavigation().extras && 
                    this.router.currentNavigation().extras.state && 
                    this.router.currentNavigation().extras.state.capabilities){
                  this.selectedInstancesFromPreviousPage = this.router.currentNavigation().extras.state.instances;
                  this.activityCapabilities = this.router.currentNavigation().extras.state.capabilities;
                  
                  //get logs package capabilities
                  if(this.activityCapabilities && this.activityCapabilities.tasks){
                    this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
                      //get supported product logs
                      if(task.type == ActivityTaskType.PACKAGE_PROD_LOGS){
                        this.supportedProductLogs = task.dataJson;
                      }
                    });
                  }
                  this.backURL = this.router.currentNavigation().extras.state.backURL;
                  this.initSupportedProductLogs();
                }else{
                  this.selectedInstancesFromPreviousPage = undefined;
                  this.backURL = undefined;
                }
  }

  get packageNameCtrl() { return this.packageForm.get('packageNameCtrl'); }

  ngOnInit(): void {
    this.agentsTableHeight = window.outerHeight < 900 ? 'calc(100vh - 500px)' : 'calc(100vh - 650px)';
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.setupid = params['setupid'];
    });

    this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
      if(data && data.type == ProductDataType.AgentManifest){
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if(data && (data.type == ProductDataType.General || data.type == ProductDataType.Updates || data.type == ProductDataType.QuickAnalysis)){
        this.solutionInfo = data.solutionInfo;
        this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
        this.isReload = this.currEnvId != this.solutionInfo.currentEnvironment.id;
        this.platform = undefined;
        this.isMasterSystemOnline = true;
        const discoveredProductGroup : DiscoveredProduct[] = data.discoveredProductGroup;

        if(discoveredProductGroup.length == 0){
          this.router.navigate(['products/overview']);
        }

        //get platform
        for(let i =0; i < discoveredProductGroup.length; i++) {
          let foundProd:ProductExt[] = (discoveredProductGroup[i].products.filter((prod:ProductExt) => {
            return prod.id == this.productId;
          }))
          if(foundProd.length > 0){
            this.platform = foundProd[0].platform;
            this.isSupportHotfix = foundProd[0].supportHotfix;

            if(this.isSupportHotfix){
              this.isQuickAnalysisRequired = !foundProd[0].isQuickAnalysisValid;
              this.isMasterSystemOnline = foundProd[0].isMasterSystemOnline;
            }
            break;
          }
        };

        if(this.platform && this.isReload){
          this.currEnvId = this.solutionInfo.currentEnvironment.id;
          this.agentRows = [];
          this.isReload = false;
          this.initView();
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.ActivityCapabilities){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.activityCapabilities = JSON.parse(msg.body.msg);
          
          
          if(this.activityCapabilities.activityType == ActivityCapabilitiesType.PACKAGE_PRODUCT_LOGS){
            //check if download log feature is supported
            if(this.activityCapabilities.ok){
              this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
                //get supported product logs
                if(task.type == ActivityTaskType.PACKAGE_PROD_LOGS){
                  this.supportedProductLogs = task.dataJson;
                }
              });

              this.initSupportedProductLogs();
            }else{
              this.router.navigate(['./'], { relativeTo: this.route.parent });
            }
          }
        }
      }else if(msg.eventType == Events.AgentStatusOffline){
        //uncheck and disable offline agents
        let isChanged:boolean = false;
        this.agentRows.forEach(row => {
          if(row.data.macAddress == msg.body.id &&
             row.data.system == msg.body.name){
            row.disableCheckbox = true;
            row.selected = false;
            if(row.data.instance && row.data.instance.agent){
              row.data.instance.agent.isOnline = false;
              row.data.agentStatus = Utils.getAgentStatus(row.data.instance.agent);
            }
            isChanged = true;
          }
        });
        if(isChanged){
          this.recountSelectedRow = !this.recountSelectedRow;
        }
      }else if(msg.eventType == Events.AgentStatusOnline){
        //enable checkbox
        let isChanged:boolean = false;
        this.agentRows.forEach(row => {
          if(row.data.macAddress == msg.body.macAddress &&
             row.data.system == msg.body.systemName){
            row.disableCheckbox = false;
            if(row.data.instance && row.data.instance.agent){
              row.data.instance.agent.isOnline = true;
              row.data.agentStatus = Utils.getAgentStatus(row.data.instance.agent);
            }
            isChanged = true;
          }
        });

        if(isChanged){
          this.recountSelectedRow = !this.recountSelectedRow;
        }
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
      }
    });
  }

  initView() {
    this.isLoading = true;
    this.getDiskspace();

    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;

        let foundComponents = this.activeProduct.components.filter((comp:ProductComponent) => {return comp.setupid === this.setupid});

        if(foundComponents.length > 0){
          this.activeComponent = foundComponents[0];
          this.activeProductInstances = this.activeProduct.instances;
          this.agentRows = [];
          this.title = $localize`Create a Logs Package`;
          this.dataService.sendData({type: ProductDataType.Title, title: this.title});
          this.dataService.sendData({type: ProductDataType.SelectTree, select: {type: ProductTreeType.COMPONENT,
                                                                            productGroupId: this.activeProduct.groupId,
                                                                            productId: this.productId, 
                                                                            setupid: this.activeComponent.setupid}});
          let masterSystemCounter:number = 0;

          for (let key in this.activeProductInstances) {  
            this.activeProductInstances[key].forEach((instance:ProductInstance) => {
              if(instance.isMasterInstance){
                masterSystemCounter++;
              }

              let instanceAgent:Agent[] = this.solutionInfo.currentEnvironment.agents.filter((agent:Agent) => {
                return agent.macAddress == key;
              });

              if(instanceAgent.length > 0){
                instance.agent = instanceAgent[0];
              }
              
              //check if the instance were selected from the previous page
              var isSelected:boolean = this.isMasterSystemOnline;

              if(this.selectedInstancesFromPreviousPage && this.selectedInstancesFromPreviousPage.length > 0){
                let matchedInstance:ProductInstance[] = this.selectedInstancesFromPreviousPage.filter((selectedInstance: ProductInstance) => {
                  return selectedInstance.system == instance.system && selectedInstance.installPath == instance.installPath;
                });

                isSelected = this.isMasterSystemOnline && matchedInstance.length > 0;
              }

              let actions:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, instance, false, true)];
              let row:DataTableRow = new DataTableRow({ system: instance.system,
                                                        installPath: instance.installPath,
                                                        version: instance.version,
                                                        platform: instance.platform,
                                                        instance: instance,
                                                        macAddress: instance.macAddress,
                                                        agentStatus: Utils.getAgentStatus(instance.agent),
                                                        viewReport: '',
                                                        metadata: instance.metadata,
                                                      },
                                                      actions,
                                                      this.isSupportHotfix && !this.isMasterSystemSelected,
                                                      isSelected,
                                                      false, 
                                                      $localize`Change primary system to resolve the issue`);
              row.disableCheckbox = !this.isMasterSystemOnline;
              if(this.activeProduct.isMultiComponent) {
                if(instance.setupId == this.setupid){
                  this.agentRows.push(row);
                }
              } else {
                this.agentRows.push(row);
              }

            });
          }
          this.isMasterSystemSelected = this.isSupportHotfix ? masterSystemCounter == 1 : true;

          if(!this.isMasterSystemSelected){
            this.router.navigate(['./'], { relativeTo: this.route.parent });
          }
        }else{
          this.router.navigate(['products/overview']);
        }          
      }),
      finalize(() => {
        if(this.activityCapabilities == undefined && this.isLoading){
          this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
          new ActivityCapabilitiesRequest(-1, ActivityType.PACKAGE_PRODUCT_LOGS, this.activeProduct.pluginId, this.activeComponent.setupid)).pipe(
          tap(resp => {
          }),
          catchError(resp => {
            Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
            this.isLoading = false;
            return of(resp);
          })).subscribe();
        }else{
          this.isLoading = false;
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  private initSupportedProductLogs(): void {

    switch (this.supportedProductLogs.descID) {
      case 'OTCS_DOWNLOAD_LOGS_DESC':
        this.supportedProductLogs.desc = $localize`To configure log levels and related settings, use the Content Server Configure Log Settings administration page. Make sure that you set the log levels appropriately for each log you select to diagnose the issue effectively.`;
        this.supportedProductLogs.info = $localize`The total size of Content Server logs, especially SQL Connect logs, can quickly become very large depending on the operation being logged. For example, enabling detailed logs during the creation of a Business Workspace that includes hundreds of Content Server items can result in logs that are numerous gigabytes in size.`;
        break;
    }

    this.supportedProductLogs.logs.forEach((log:ProductLog) => {
      switch(log.id){
        case 'THREAD_SUMMARY_TIMING_LOGS':
          log.name = $localize`Thread Summary Timing Logs`;
          break;
        case 'THREAD_LOGS':
          log.name = $localize`Thread Logs`;
          break;
        case 'SQL_CONNECT_LOGS':
          log.name = $localize`SQL Connect Logs`;
          break;
        case 'TRACE_LOGS':
          log.name = $localize`Trace Logs`;
          break;
        case 'WEB_SERVER_CLIENT_LOGS':
          log.name = $localize`Web Server Client Logs`;
          break;
        case 'WEB_SERVER_CLIENT_TIMING_LOGS':
          log.name = $localize`Web Server Client Timing Logs`;
          break;
        case 'SECURITY_LOGS':
          log.name = $localize`Security Logs`;
          break;
        case 'SUPPLEMENTAL_LOGS':
          log.name = $localize`Supplemental Logs`;
          break;
        case 'ARCHIVE_STORAGE_PROVIDER_LOGS':
          log.name = $localize`Archive Storage Provider Logs`;
          break;
        case 'OTDS_LOGS':
          log.name = $localize`Directory Services Logs`;
          break;
        case 'TOMCAT_LOGS':
          log.name = $localize`Tomcat Logs`;
          break;
        case 'AS_LOGS':
          log.name = $localize`Archive Server Logs`;
          break;
        case 'AS_STORAGE_MGR_LOGS':
          log.name = $localize`Storage Manager Logs`;
          break;
        case 'AS_SYSTEM_STATS_LOGS':
          log.name = $localize`System Statistics Job Logs`;
          break;
        case 'MONS_LOGS':
          log.name = $localize`Archive Monitoring Server Logs`;
          break;
        case 'DP_BASE_LOGS':
          log.name = $localize`Document Pipelines Logs`;
          break;
        case 'SYSREPORT_LOGS':
          log.name = $localize`System Report`;
          break;
        case 'SYS_PERF_REPORT_LOGS':
          log.name = $localize`System Performance Report`;
          break;
        case 'SEARCH_PROCESS_LOGS':
          log.name = $localize`Search Process Logs`;
          break  
        case 'ASSET_SERVICE_LOGS':
          log.name = $localize`Asset Service Logs`;
          break;
        case 'CONFIG_SERVICE_LOGS':
          log.name = $localize`Configuration Service Logs`;
          break;
        case 'MARKUP_SERVICE_LOGS':
          log.name = $localize`Markup Service Logs`;
          break;
        case 'PUBLICATION_SERVICE_LOGS':
          log.name = $localize`Publication Service Logs`;
          break;
        case 'PUBLISHER_SERVICE_LOGS':
          log.name = $localize`Publisher Service Logs`;
          break;
        case 'SEARCH_SERVICE_LOGS':
          log.name = $localize`Search Service Logs`;
          break;
        case 'VIEWER_SERVICE_LOGS':
          log.name = $localize`Viewer Service Logs`;
          break;
        case 'SERVER_MANAGER_LOGS':
          log.name = $localize`Server Manager Logs`;
          break;
        case 'CONTENT_MANAGER_LOGS':
          log.name = $localize`Content Manager Logs`;
          break;
        case 'APPLICATION_SERVER_LOGS':
          log.name = $localize`Application Server Logs`;
          break;
        case 'OUTPUT_SERVER_LOGS':
          log.name = $localize`Output Server Logs`;
          break;
        case 'DOCUMENT_SERVER_LOGS':
          log.name = $localize`Document Server Logs`;
          break;
        case 'ENTERPRISE_CONVERSION_SERVER_LOGS':
          log.name = $localize`Enterprise Conversion Server Logs`;
          break;
      }

      if(this.isSelectAllChecked && !log.isSelected){
        this.isSelectAllChecked = false;
      }
    });

    //set column numbers based on the number of supported log types
    let numCol:number = Math.ceil(this.supportedProductLogs.logs.length / 4);
    this.logColClass = this.logColClass + " " + (numCol <= 12 ? `ot-grid--is-${numCol}-columns` : 'ot-grid--is-12-columns');
    this.isLoading = false;
  }

  onSupportedLogsChanged(): void {
    let unselectedLogs:ProductLog = this.supportedProductLogs.logs.find(log => !log.isSelected);
    this.isSelectAllChecked = unselectedLogs == undefined ? true : false;
  }

  toggleSelectAllSupportedLogs(): void {
    this.supportedProductLogs.logs.forEach((log:ProductLog) => {
      log.isSelected = this.isSelectAllChecked;
    });
  }
  
  private openDetails(data: any): void{
    this.modal.open(InstanceDetailsComponent, {
      data: {
        instanceMetaData: JSON.parse(data.instance ? data.instance.metadata : data.metadata),
        productName: this.activeProduct.name + ' ' + this.activeProduct.version,
        supportHotfix: this.isSupportHotfix,
        id: 'otsc-products-downloadLogs-details-dialog'
      }
    });
  }

  rowClick(event: any): void{
    this.openDetails(event.data);
  }
  
  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.openDetails(event.data[0]);
    }
  }
  
  start(showConfirmMsg:boolean = false): void {
    if(showConfirmMsg){
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            title: $localize`Create a Logs Package`,
            type: ModalMessageType.Question,
            message: $localize`Would you like to create a Logs Package?`,
            primaryBtn: $localize`Yes`,
            secondaryBtn: $localize`No`,
            width: '355px'
          },
          id: 'otsc-start-prod-log-task-msg'
        }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
          if(isPrimaryBtnClicked){
            this.sendCreatePkgRequest();
          }
          sub.unsubscribe();
        });
  }else{
      this.sendCreatePkgRequest();
    }
  }

  sendCreatePkgRequest():void {
    this.started = true;
    if (this.agentRows !== undefined && this.agentRows.length > 0) {
      this.agentRows.forEach(agent => {
        agent.disableCheckbox = true;
      });
    }

    //gather req parameters
    let selectedLogs: string[] = [];

    this.supportedProductLogs.logs.forEach((log:ProductLog) => {
      if(log.isSelected){
        selectedLogs.push(log.id);
      }
    });

    let instancesMap:Object = new Object();

    this.agentRows.forEach( (row: DataTableRow) => {
      if(row.selected){
        if (instancesMap[row.data.macAddress]) {
          instancesMap[row.data.macAddress].push(row.data.installPath);
        }else{
          let installPathList:string[] = [];
          installPathList.push(row.data.installPath);
          instancesMap[row.data.macAddress] = installPathList;
        }
      }
    });

    let pkgProdLogsReq:PackageProductLogsRequest = new PackageProductLogsRequest(this.solutionInfo.currentEnvironment.id,
                                                                              this.packageNameCtrl.value,
                                                                              this.activeProduct.pluginId,
                                                                              selectedLogs,
                                                                              instancesMap,
                                                                              this.productURL,
                                                                              this.productToken
                                                                              );
    
    this.siService.packageProductLog(pkgProdLogsReq).pipe(
      tap(resp => {
        this.router.navigate(['/products/logsPackageDownloads']);
      }),
      catchError(resp => {
        const sub: Subscription =
          this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Error`,
              type: ModalMessageType.Error,
              message: $localize`An error occurred creating a Logs Package. Please check the logs for more details.`,
              primaryBtn: $localize`Close`,
              width: '550px'
            },
            id: 'otsc-prod-create-log-error-msg'
          }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
            this.started = false;
            sub.unsubscribe();
          });
        return of(resp);
      })
    ).subscribe();
  }

  back(): void{
    if(this.backURL == undefined || this.backURL == ''){
      this.router.navigate(['./'], { relativeTo: this.route.parent });
    }else{
      this.router.navigate([this.backURL], { relativeTo: this.route.parent });
    }
  }

  getSelectedAgentCount(): number {
    let selectedAgentCount: number = 0;
    if (this.agentRows !== undefined && this.agentRows.length > 0) {
      this.agentRows.forEach(agent => {
        if (agent.selected) {
          selectedAgentCount++;
        }
      });
    }

    return selectedAgentCount;
  }

  isReadyToStart(): boolean {
    let isReady: boolean = false;
    if(!this.started){
      if(this.packageForm.valid && this.supportedProductLogs.logs.find(log => log.isSelected) && this.getSelectedAgentCount() > 0){
        isReady = true;
      }
    }
    return isReady;
  }

  validateTasks(): void {
    let isAuthRequired: boolean = false;
    for (let i = 0; i < this.supportedProductLogs.logs.length; i++) {
      if (this.supportedProductLogs.logs[i].isSelected &&
        this.supportedProductLogs.logs[i].isAuthRequired) {
        isAuthRequired = true;
        break;
      }
    }
    if(isAuthRequired) {
      this.openLoginDialog();
    } else {
      this.sendPackageLogsRequest();
    }

  }

  sendPackageLogsRequest(): void {
    this.siService.getProdLogTasks(this.solutionInfo.currentEnvironment.id, this.activeComponent?.setupid).pipe(
      tap(resp => {
        this.logTaskResponse = resp.body;
        if (this.logTaskResponse.count < 3) {
          this.start(true);
        } else {
          let nextTaskToDelete: ProdLogTask = this.getNextLogToDelete(this.logTaskResponse);
          if (nextTaskToDelete == undefined) {
            this.openQueuedMessageDialog();
          } else {
            this.openDeleteLastLogDialog(this.logTaskResponse.tasks[this.logTaskResponse.tasks.length - 1]);
          }

        }
      })
    ).subscribe();
  }

  getNextLogToDelete(resp: ProdLogTaskResponse): ProdLogTask{
    let task: ProdLogTask = undefined;
    for (let i = resp.tasks.length - 1; i > -1; i--){
      if (resp.tasks[i].status == "ERROR" || resp.tasks[i].status == "COMPLETED" || resp.tasks[i].status == "CANCELED"){
        task = resp.tasks[i];
        break;
      }
    }
    return task;
  } 

  openQueuedMessageDialog() : void{
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Error`,
          type: ModalMessageType.Error,
          message: $localize`System Center Manager stores a maximum of three Logs Packages per product. There are currently too many tasks queued, your request cannot be started at this time. You can cancel any of the queued log tasks on the Activities page.`,
          primaryBtn: $localize`Close`,
          width: '575px'
        },
        id: 'otsc-prod-queued-log-task-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        this.started = false;
        sub.unsubscribe();
      });
  }

  openDeleteLastLogDialog(task: ProdLogTask): void{
    let formattedData = new FromNowPipe().transform(task.createdDateTime.toString());
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Warning`,
          type: ModalMessageType.Warning,
          message: $localize`System Center Manager stores a maximum of three Logs Packages per product. To complete your request, System Center Manager will delete Package '${task.prefix}' created ${formattedData}. The time required to delete Package '${task.prefix}' depends on the size of the log files in it.<br/>To delete package '${task.prefix}' and create a new Logs Package, click <b>Yes</b>.<br/>`,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '585px'
        },
        id: 'otsc-start-prod-log-task-warning-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.siService.deleteTasks([task.uuid], this.solutionInfo.currentEnvironment.id).pipe(
            tap(resp => {
              this.start();
            })
          ).subscribe();
        }else{
          this.started = false;
        }
        sub.unsubscribe();
      });
  }

  getDiskspace(): void {
    this.supportService.getManagerDiskSpace().pipe(
      tap(resp => {
        let sysInfo = resp.body;
        if(sysInfo !== undefined){
          this.freeDiskSpace = new FileSizePipe().transform(sysInfo.diskFree);
        }
      })
    ).subscribe();
  }

  openLoginDialog(): void {
    let masterSystem = this.getMasterInstance();
    let productInstance = this.activeProductInstances[Object.keys(this.activeProductInstances)[0]][0];
    let macAddress: string = (masterSystem == null) ? productInstance.macAddress : masterSystem.macAddress;

    const sub: Subscription =
      this.modal.open(LoginPackageLogsComponent, {
        data: {
          title: $localize`Sign in`,
          description: $localize`In order to package the requested logs you must have a valid ${this.activeProduct.name} account. Enter the information below and press Authenticate to proceed.`,
          macAddress: macAddress,
          product: this.activeProduct.name,
          plugin: this.activeProduct.pluginId,
          url: (masterSystem == null) ? productInstance.instanceURL : masterSystem.instanceURL,
          host: productInstance.system,
          installDirectory: productInstance.installPath
        },
        id: 'otsc-package-logs-auth'
      }).afterClosed.subscribe((result: ProductLoginResult) => {
        if (result && result.ok){
          this.productURL = result.url;
          this.productToken = result.token;
          this.sendPackageLogsRequest();
        }
        sub.unsubscribe();
      });
  }

  getMasterInstance(): ProductInstance {
    let masterSystem: ProductInstance = null;
    let keys: string[] = Object.keys(this.activeProductInstances);
    for(let i = 0; i < keys.length; i++){
      let instances = this.activeProductInstances[keys[i]];
      for(let j = 0; j < instances.length; j++){
        if(instances[j].isMasterInstance){
          masterSystem = instances[j];
          break;
        }
      }
      if(masterSystem != null){
        break;
      }
    }
    return masterSystem;
  }
}